export enum StringFilterOption {
  Eq = 'eq',
  Ne = 'ne',
}
export type AvailableOptions = StringFilterOption[];

export const salesOrderTypesFormatted: Record<string, string> = {
  SalesOrder: 'Sales Order',
  Proforma: 'Proforma',
};

export const failedSalesOrderStatuses = [
  { label: 'Sending Stopped', value: 'Sending Stopped' },
  { label: 'Sending Failed', value: 'Sending Failed' },
  { label: 'Sending Scheduling Failed', value: 'Sending Scheduling Failed' },
];

export const sentSalesOrderStatuses = [{ label: 'Sent', value: 'Sent' }];

export const scheduledSalesOrderStatuses = [
  { label: 'Sending Paused', value: 'Sending Paused' },
  { label: 'Sending Scheduled', value: 'Sending Scheduled' },
];

export const billingTypes = [
  { label: salesOrderTypesFormatted.SalesOrder, value: 'SalesOrder' },
  { label: salesOrderTypesFormatted.Proforma, value: 'Proforma' },
];

export const allSalesOrderStatuses = [
  ...failedSalesOrderStatuses,
  ...sentSalesOrderStatuses,
  ...scheduledSalesOrderStatuses,
  { label: 'Created', value: 'Created' },
];

export const extractSubMenuStatusFilters = () => {
  return allSalesOrderStatuses;
};
